import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const resources = {
  en: {
    translation: {
      Undo: 'Undo',
      edit: 'edit',
      Edit: 'edit',
      delete: 'delete',
      Delete: 'delete',
      editImage: 'Edit Image',
      imageSaved: '{{imageName}} saved',
      rawLaTeX: 'Raw LaTeX',
      selectWithMouse: 'Select with mouse',
      on: 'on',
      copyToClipboard: 'Copy to clipboard',
      LaTeXCopied: 'LaTeX expression copied to clipboard',
      mediaSaved: '{{mediaName}} saved',
      setItemName: 'Set the name of the item',
      Save: 'Save',
      Reset: 'Reset',
      'Click to edit': 'Click to edit',
      'Edit Image': 'Edit Image',
      'Save & Close': 'Save & Close',
      itemDeleted: '{{itemName}} deleted',
      itemCopied: '\'{{itemName}}\' copied to your clipboard (paste in node to use)`',
      'Pressing alt + 1 in a node will insert this item': 'Pressing alt + 1 in a node will insert this item',
      'How to export': 'How to export',
      howToAnki: 'How to export LO\'s data to Anki',
      explanationForAnki: {
        '1': 'First, you should install AnkiConnect to your Anki. The image below is the installation guide taken from their page.',
        '2': 'Next, you need to set up AnkiConnect. You should paste https://app.learnobit.com somewhere. Follow the GIF below.',
        '3': 'Then select the one you want to export through \'Anki\' in the sidebar of the app and export it. That\'s it.',
        '4': 'here is a limit: For now, media and learning records are not exported together.',
        '5': 'If people want, I can try to make it so that the media is exported together. It is more difficult to export learning records together.'
      },
      'Export to Anki': 'Export to Anki',
      'It couldn\'t find Anki running': 'It couldn\'t find Anki running',
      'Some error occurred': 'Some error occurred',
      'How to Add': 'How to Add',
      'Running the Course for': 'Running the Course for',
      'Total Synapses': 'Total Synapses',
      'Target Synapses': 'Target Synapses',
      'Formed Synapses': 'Formed Synapses',
      'Percentage': 'Percentage',
      'Target Notes': 'Target Notes',
      'Completed Notes': 'Completed Notes',
      'In This Course': 'In This Course',
      'Target': 'Target',
      'Skipped': 'Skipped',
      'Being Thoroughly Reviewed': 'Being Thoroughly Reviewed',
      'You are running this course with default settings': 'You are running this course with default settings',
      'Something went wrong. Maybe the file is invalid.': 'Something went wrong. Maybe the file is invalid.',
      Import: 'Import',
      'Reset Learning Records': 'Reset Learning Records',
      'Import as a New File': 'Import as a New File',
      'Export as a Local File': 'Export as a Local File',
      'Export as an Anki deck': 'Export as an Anki deck',
      'Open': 'Open',
      'Add to Bookmarks': 'Add to Bookmarks',
      'Share': 'Share',
      'Stop Sharing': 'Stop Sharing',
      'Category': 'Category',
      'New Category': 'New Category',
      'Add a New File': 'Add a New File',
      'ANONYMOUS': 'ANONYMOUS',
      'Note Garden for ': 'Note Garden for ',
      explanationForLearningTricks: {
        '1': 'These are a number of tricks that can boost your learning, but can be annoying.',
        '2': 'You can selectively activate these, depending on your taste.',
        '3': '(There are a number of tricks already applied by default that don\'t seem likely to annoy you.',
        '4': 'Click <1>here</1> for those.)',
        '5': 'Prevents early checking of the answer in the notes',
        '6': '(Click this button if you want to know what this means)',
        '7': 'Don\'t Show Answers',
        '8': 'Celebrate intermittently during courses',
        '9': '(works better than celebrating every time)',
        '10': 'Intermittent Reinforcement',
        '11': 'Make answer parts hard to read',
        '12': '(Research shows that just doing this boosts the learning effect)',
        '13': 'Obfuscation',
        '14': 'Break Schedule',
        '15': 'Insert short breaks during courses',
        '16': '(Research shows that these kinds of breaks boost learning)',
        '17': 'Early Short Break',
        '18': 'It is well-known that time management techniques which focus on fixed amounts of time and put a break at every interval increase productivity',
        '19': '(In particular, according to research, the combination of working 52 minutes and having a break for 17 minutes works best)',
        '20': 'Long Break',
        '21': 'Recommended Break Ratio',
        '22': 'Pomodoro',
        '23': 'Learning :',
        '24': 'Break :',
        '25': 'Short Break :',
        '26': 'Repetition:',
        '27': 'Long Break:',
        '28': 'Ambient Sound',
        '29': '1. Sci-fi',
        '30': '2. Downtown',
        '31': '3. Nature',
        '32': '4. Rain',
        '33': 'Insert several effects that can stimulate dopamine during courses',
        '34': 'Dopamine Boosting',
        '35': 'Ambient sound that boosts concentration during courses '
      },
      'Turn on Sound': 'Turn on Sound',
      'Turn Off Sound': 'Turn Off Sound',
      'Deactivate All': 'Deactivate All',
      'Activate All': 'Activate All',
      'Limit Node Height': 'Limit Node Height',
      'Restore': 'Restore',
      '& Close Others': '& Close Others',
      'The URL for sharing is copied': 'The URL for sharing is copied',
      explanationForChatMemo: {
        '1': 'It\'s a tool designed for typing an unfiltered stream of consciousness, and then throwing it away',
        '2': 'You can open and focus on it with alt + q anywhere in LO',
        '3': 'Close it with {{combo}}',
        '4': 'If you hit alt + q while focusing on this, you will refocus on the previously focused node',
        '5': 'alt + q to type anywhere'
      },
      'History': 'History',
      'Reload': 'Reload',
      'Hard Reload': 'Hard Reload',
      'No results': 'No results',
      'Search and select nodes including their descendants': 'Search and select nodes including their descendants',
      'Yes': 'Yes',
      'No': 'No',
      'Do you really want to end up halfway?': 'Do you really want to end up halfway?',
      'How about installing the desktop version?': 'How about installing the desktop version?',
      'Install': 'Install',
      'Loading Configs': 'Loading Configs',
      'Reset Configs': 'Reset Configs',
      'Files': 'Files',
      'Bookmarks': 'Bookmarks',
      'Learn': 'Learn',
      'To Do List': 'To Do List',
      'Export': 'Export',
      'ChatMemo': 'ChatMemo',
      'Help': 'Help',
      'Check as Questions': 'Check as Questions',
      'Font': 'Font',
      'Highlight': 'Highlight',
      'Box Highlight': 'Box Highlight',
      'Numbered List': 'Numbered List',
      'Heading': 'Heading',
      'Convert to a Spreadsheet Node': 'Convert to a Spreadsheet Node',
      'Convert to a Document Node': 'Convert to a Document Node',
      'Image': 'Image',
      'Drawing': 'Drawing',
      'Code': 'Code',
      'More Menus': 'More Menus',
      'Go to Sign Up': 'Go to Sign Up',
      'My Page': 'My Page',
      'Dashboard': 'Dashboard',
      'Settings': 'Settings',
      'Shared Nodes': 'Shared Nodes',
      'Deleted Nodes': 'Deleted Nodes',
      'Dark Mode': 'Dark Mode',
      'Preferences': 'Preferences',
      'Import / Export': 'Import / Export',
      'Memorize Records': 'Memorize Records',
      'Close': 'Close',
      'Learned': 'Learned',
      'Current Streak': 'Current Streak',
      'Longest Streak': 'Longest Streak',
      'Level': 'Level',
      'Next Level': 'Next Level',
      'Points to the Next Level': 'Points to the Next Level',
      'Synapses': 'Synapses',
      'Run Count': 'Run Count',
      'Complete Count': 'Complete Count',
      totalNotes: 'Total Note: {{count}}',
      totalNotes_plural: 'Total Notes: {{count}}',
      totalQuestions: 'Total Question: {{count}}',
      totalQuestions_plural: 'Total Questions: {{count}}',
      New: 'New',
      'To Review': 'To Review',
      '~ 10 days': '~ 10 days',
      '10 ~ 100 days': '10 ~ 100 days',
      '100 ~ days': '100 ~ days',
      'Status': 'Status',
      'Predicted Ratings': 'Predicted Ratings',
      'Kind': 'Kind',
      'Show': 'Show',
      'predictedRatings': 'Predicted <1/> Ratings',
      'Easy': 'Easy',
      'easy': 'Easy',
      'Normal': 'Normal',
      'normal': 'Normal',
      'Hard': 'Hard',
      'hard': 'Hard',
      'Fail': 'Fail',
      'fail': 'Fail',
      'Node': 'Node',
      'Row': 'Row',
      'Fragment': 'Fragment',
      Blank: 'Blank',
      Deleted: 'Deleted',
      'Include Skipped Notes': 'Include Skipped Notes',
      'Open in a Big Window': 'Open in a Big Window',
      'Remove from the Board': 'Remove from the Board',
      'Add Charts': 'Add Charts',
      'Untitled': 'Untitled',
      'Add a New Document': 'Add a New Document',
      'Nothing Found': 'Nothing Found',
      'There is nothing to insert from Waiting Items of Type 1': 'There is nothing to insert from Waiting Items of Type 1',
      insertedFromT1: '{{itemName}} inserted from Type 1',
      'Collapse': 'Collapse',
      'Expand': 'Expand',
      'Remove from Bookmarks': 'Remove from Bookmarks',
      'Add node': 'Add node',
      'Transfer': 'Transfer',
      'Move': 'Move',
      'Upload Type 2 Node': 'Upload Type 2 Node',
      'Spreadsheet Node': 'Spreadsheet Node',
      'Open in a New Window': 'Open in a New Window',
      'Enter This Node': 'Enter This Node',
      'Toggle Visibility of Child Nodes': 'Toggle Visibility of Child Nodes',
      'Add a Node Upside': 'Add a Node Upside',
      'Add a Node Downside': 'Add a Node Downside',
      'tab': 'tab',
      'shift+tab': 'shift+tab',
      'Transfer It to Down': 'Transfer It to Down',
      'Transfer It to Up': 'Transfer It to Up',
      'Focus on the Parent Node': 'Focus on the Parent Node',
      'Focus on the Upper Node': 'Focus on the Upper Node',
      'Focus on the Lower Node': 'Focus on the Lower Node',
      'This triangle has no interaction': 'This triangle has no interaction',
      'Increase font size': 'Increase font size',
      'Decrease font size': 'Decrease font size',
      Question: 'Question',
      Answer: 'Answer',
      'It shows multiple cards in the Memorize section': 'It shows multiple cards in the Memorize section',
      'Show Multiple Cards': 'Show Multiple Cards',
      'front': 'front',
      'back': 'back',
      'Insert media from Type 1': 'Insert media from Type 1',
      'Select columns to show': 'Select columns to show',
      'You can\'t have a column with that name': 'You can\'t have a column with that name',
      'You can\'t have columns with the same name': 'You can\'t have columns with the same name',
      'Start Something': 'Start Something',
      'Name of new Column': 'Name of new Column',
      'Add Column': 'Add Column',
      'Delete Column': 'Delete Column',
      'Delete Selected Rows': 'Delete Selected Rows',
      'In the Memorize section, it covers all the parts you have cropped': 'In the Memorize section, it covers all the parts you have cropped',
      'Otherwise, it covers only the parts you need to recall.': 'Otherwise, it covers only the parts you need to recall.',
      'It shows multiple fragments in the Memorize section': 'It shows multiple fragments in the Memorize section',
      'Show Multiple Fragments': 'Show Multiple Fragments',
      '\'Media Answer\' is to cover part of the original media and guess what the part was.': '\'Media Answer\' is to cover part of the original media and guess what the part was.',
      '\'Text Answer\' is to look at a part of the original media and guess what the text you entered was.': '\'Text Answer\' is to look at a part of the original media and guess what the text you entered was.',
      'Media Answer': 'Media Answer',
      'Text Answer': 'Text Answer',
      'Sharing stopped': 'Sharing stopped',
      'URL for sharing is copied': 'URL for sharing is copied',
      'Top Root': 'Top Root',
      'LearnObit follows a tree structure': 'LearnObit follows a tree structure',
      ' and this is the top-level root node': ' and this is the top-level root node',
      'Scroll Up': 'Scroll Up',
      'Scroll Down': 'Scroll Down',
      'Focus on Last Focused Node': 'Focus on Last Focused Node',
      'Focus on the Node of This Window': 'Focus on the Node of This Window',
      'Focus on Last Opened Window': 'Focus on Last Opened Window',
      'Focus on Previously Focused Window': 'Focus on Previously Focused Window',
      'Enter the Parent Node': 'Enter the Parent Node',
      'Toggle ChatMemo': 'Toggle ChatMemo',
      'Toggle Menu': 'Toggle Menu',
      'Close All Except for This Window': 'Close All Except for This Window',
      'Expand Window': 'Expand Window',
      'Split Window': 'Split Window',
      'Close Window': 'Close Window',
      'Long Break Time!': 'Long Break Time!',
      'Typing Unfiltered Stream of Consciousness, And Then Throw It Away': 'Typing Unfiltered Stream of Consciousness, And Then Throw It Away',
      'Fight Distractions': 'Fight Distractions',
      'Skip Break': 'Skip Break',
      inhale: 'Inhale',
      hold: 'Hold',
      exhale: 'Exhale',
      takeBreath: 'Take {{count}} Deep Breath',
      takeBreath_plural: 'Take {{count}} Deep Breaths',
      pomo: '{{count}} Pomo',
      pomo_plural: '{{count}} Pomos',
      'Full Screen': 'Full Screen',
      'Limit of volume in a course': 'Limit of volume in a course',
      delayOn1: 'Increase the next interval of notes given a rating after {{delayValue}} o\'clock by 1 day',
      delayOn2: 'Don\'t increase interval because of late learning',
      'Descendants of the node that was failed to recall': 'Descendants of the node that was failed to recall',
      'Make all notes appear': 'Make all notes appear',
      'Make direct child notes (1 depth) not to appear': 'Make direct child notes (1 depth) not to appear',
      'Make all descendant notes never appear': 'Make all descendant notes never appear',
      'Fit the order of courses tightly to the tree structure': 'Fit the order of courses tightly to the tree structure',
      'The number of questions(s)': 'The number of questions(s)',
      'Predicted Rating': 'Predicted Rating',
      'To the easier rating than the last rating': 'To the easier rating than the last rating',
      'Interval Weight': 'Interval Weight',
      'Difficulty Weight': 'Difficulty Weight',
      'How many fail records are required to allow the predicted rating to fail': 'How many fail records are required to allow the predicted rating to fail',
      'Spaced Repetition': 'Spaced Repetition',
      'Algorithm Description': 'Algorithm Description',
      'Rating Values': 'Rating Values',
      'Set exactly how much difficulty each rating represents (the higher, the easier)': 'Set exactly how much difficulty each rating represents (the higher, the easier)',
      'Default': 'Default',
      'Apply': 'Apply',
      'Exclude selected nodes and their descendants in courses': 'Exclude selected nodes and their descendants in courses',
      'Include all selected nodes and their descendants in courses': 'Include all selected nodes and their descendants in courses',
      'without considering the review schedule': 'without considering the review schedule',
      'Run courses only for selected nodes and their descendants': 'Run courses only for selected nodes and their descendants',
      'All Checked': 'All Checked',
      'Some Checked': 'Some Checked',
      'Skip All': 'Skip All',
      'Show Answers': 'Show Answers',
      'Edit imperatively': 'Edit imperatively',
      'Save and Close': 'Save and Close',
      'Learning Ticks': 'Learning Ticks',
      'youFormedSynapses': 'You\'ve Formed <2>{{synapses}}</2> Synapses!',
      'Learn These Parts': 'Learn These Parts',
      'You Have Nothing to Review': 'You Have Nothing to Review',
      'Run the Course': 'Run the Course',
      youLearnedNote: 'You Learned {{count}} Note',
      youLearnedNote_plural: 'You Learned {{count}} Notes',
      Before: 'Before',
      After: 'After',
      'It\'s Prevented to Check Answers by the Learning Tricks Option': 'It\'s Prevented to Check Answers by the Learning Tricks Option',
      'Press to change color. Nothing else but quite useful': 'Press to change color. Nothing else but quite useful',
      'Don\'t Know': 'Don\'t Know',
      'Know': 'Know',
      'Skip': 'Skip',
      'Know (enter)': 'Know (enter)',
      'Don\'t Know (1)': 'Don\'t Know (1)',
      'Previous': 'Previous',
      'All Notes Are Rated': 'All Notes Are Rated',
      'Rate Unrated Notes at Once': 'Rate Unrated Notes at Once',
      'Move on to the Next (enter)': 'Move on to the Next (enter)',
      'Rate with the Predicted Rating': 'Rate with the Predicted Rating',
      'Failed to Recall': 'Failed to Recall',
      'Switch to Detailed Ratings': 'Switch to Detailed Ratings',
      'Switch to Simple Ratings': 'Switch to Simple Ratings',
      'Here you can change your rating': 'Here you can change your rating',
      'The mobile version is not ready yet': 'The mobile version is not ready yet',
      'The user did not allow this node to be shared': 'The user did not allow this node to be shared',
      'Shared node was deleted by the user': 'Shared node was deleted by the user',
      'Something went wrong': 'Something went wrong',
      'Go to LearnObit Page': 'Go to LearnObit Page',
      'Something went wrong and the data was not saved properly. Sorry.': 'Something went wrong and the data was not saved properly. Sorry.',
      'Any changes you make here will not be reflected in the original data': 'Any changes you make here will not be reflected in the original data',
      'Data for guest users will not be saved': 'Data for guest users will not be saved',
      'Any changes you make in Playground will not be saved': 'Any changes you make in Playground will not be saved',
      'Organize for Memorizing': 'Organize for Memorizing',
      'Organize for Reference': 'Organize for Reference',
      'LearnObit has updated to the latest version!': 'LearnObit has updated to the latest version!',
      'LearnObit is ready for offline usage': 'LearnObit is ready for offline usage',
      'Nodes saved': 'Nodes saved',
      nodeDeleted: 'Your Node {{nodeTitle}} Deleted',
      'It\'s offline mode': 'It\'s offline mode',
      'It\'s online mode': 'It\'s online mode',
      'LearnObit is being opened in several windows. it might work in a strange way.': 'LearnObit is being opened in several windows. it might work in a strange way.',
      'Try LearnObit without signing up': 'Try LearnObit without signing up',
      'Sign up here': 'Sign up here',
      'Back': 'Back',
      'Next': 'Next',
      'Last': 'Last',
      'CANCEL': 'CANCEL',
      'Email': 'Email',
      'Continue as a guest': 'Continue as a guest',
      'Sign in with email': 'Sign in with email',
      'Sign in with google': 'Sign in with google',
      'Choose files...': 'Choose files...',
      'Recent': 'Recent',
      'Nothing Here': 'Nothing Here',
      'Course Settings': 'Course Settings',
      'Include These All': 'Include These All',
      'Notes saved': 'Notes saved',
      'Learn All Parts': 'Learn All Parts',
      'Add a To Do item (alt + t Anywhere)': 'Add a To Do item (alt + t Anywhere)',
      'Enter': 'Enter',
      'Clear': 'Clear',
      'Sign Out': 'Sign Out',
      'New Page': 'New Page',
      'Nodes that Link to This Node': 'Nodes that Link to This Node',
      'Completed It All!': 'Completed It All!',
      'Results': 'Results',
      'Hide All Fragments': 'Hide All Fragments',
      'Notes': 'Notes',
      'Not Rated': 'Not Rated',
      'Don\'t Check Answers': 'Don\'t Check Answers',
      'Why? Read More': 'Why? Read More',
      'Copy': 'Copy',
      'Paste': 'Paste',
      'Control': 'Control',
      'Add Node': 'Add Node',
      'Refresh': 'Refresh',
      'Move Focus': 'Move Focus',
      'Right click on the circle of the node': 'Right click on the circle of the node',
      windowExplanation: 'This window is for {{nodeTitle}}',
      'Sign In': 'Sign In',
      'Sign Up': 'Sign Up',
      'Copy the URL for Sharing': 'Copy the URL for Sharing',
      // -----------------------------------------------------------------------------------------------------------
      'Generate cloze by clicking words': 'Generate cloze by clicking words',
      'Loading Data': 'Loading Data',
      'Open a Rich Editor': 'Open a Rich Editor',
      'Change Language': 'Change Language',
      English: 'English',
      Korean: 'Korean'
    }
  },
  ko: {
    translation: {
      Undo: '되돌리기',
      edit: '편집',
      Edit: '편집',
      delete: '삭제',
      Delete: '삭제',
      editImage: '이미지 편집',
      imageSaved: '{{imageName}} 저장됨',
      rawLaTeX: 'LaTeX',
      selectWithMouse: '마우스로 선택',
      on: '켜기',
      copyToClipboard: '클립보드로 복사',
      LaTeXCopied: 'LaTeX이 클립보트에 복사 되었습니다.',
      mediaSaved: '{{mediaName}} 저장됨',
      setItemName: '항목 이름 설정',
      Save: '저장',
      Reset: '초기화',
      'Click to edit': '선택하여 편집',
      'Edit Image': '이미지 편집',
      'Save & Close': '저장하고 나가기',
      itemDeleted: '{{itemName}} 삭제되었습니다.',
      itemCopied: '\'{{itemName}}\' 클립보드에 복사되었습니다. (사용할 노드로 복사)`',
      'Pressing alt + 1 in a node will insert this item': '노드에서 alt + 1을 누르면 이 항목이 삽입됩니다.',
      'How to export': '내보내는 방법',
      howToAnki: 'Anki로 내보내는 방법i',
      explanationForAnki: {
        '1': '첫째, 당신의 Anki에 Ankiconnect를 설치해야 합니다. 아래의 이미지는 Anki 페이지의 설치 가이드입니다.',
        '2': '둘째, 당신은 AnkiConnect를 준비해야 합니다. https://app.learnobit.com로 가세요. 그리고 아래의 GIF를 따르세요.',
        '3': '셋째, 앱의 사이드바에서 Anki로 내보내고 싶은 것을 선택하고 내보내세요.',
        '4': '예외. 아직까지 미디어와 학습기록은 함께 내보낼 수 없습니다.',
        '5': '여러분이 원하신다면, 미디어를 함께 내보낼 수 있도록 해보겠습니다. 학습자료를 함께 내보낼 수 있도록 하는 것은 더 어렵습니다.'
      },
      'Export to Anki': 'Anki로 내보내기',
      'It couldn\'t find Anki running': '실행되는 Anki를 찾지 못했습니다.',
      'Some error occurred': '이런! 에러가 일어났습니다.',
      'How to Add': '추가하는 법',
      'Running the Course for': '이 부분을 학습 합니다! ',
      'Total Synapses': '전체 가드닝 포인트',
      'Target Synapses': ' 획득 가드닝 포인트',
      'Formed Synapses': '형성된 가드닝 포인트',
      'Percentage': '퍼센트',
      'Target Notes': '목표 노트 ',
      'Completed Notes': '완료된 노트',
      'In This Course': '이 학습 코스에서',
      'Target': '대상',
      'Skipped': '건너뛰기',
      'Being Thoroughly Reviewed': '전부 복습하기',
      'You are running this course with default settings': '이 학습은 초기 설정으로 진행됩니다.',
      'Something went wrong. Maybe the file is invalid.': '뭔가 잘못됐어요! 아마 파일이 잘못된 것 같네요ㅠㅠ',
      Import: '불러오기',
      'Reset Learning Records': '학습기록 초기화',
      'Import as a New File': '새로운 파일로 불러오기',
      'Export as a Local File': '기기로 내보내기',
      'Export as an Anki deck': 'Anki 덱으로 내보내기',
      'Open': '열기',
      'Add to Bookmarks': '북마크 추가',
      'Share': '공유하기',
      'Stop Sharing': '공유 중지',
      'Category': '분류',
      'New Category': '새 분류',
      'Add a New File': '새 파일로 추가하기',
      'ANONYMOUS': '손님계정',
      'Note Garden for ': '~~ 의 노트가든',
      explanationForLearningTricks: {
        '1': '여러분들을 도와 줄 수 있는 여러가지 학습 보조기능이 있습니다!',
        '2': '여러분들의 입맛에 맞는 기능을 선택하세요!',
        '3': '(이미 적용된 학습보조기능이 있을수 있습니다!)',
        '4': '<1>here</1> 을 클릭하세요',
        '5': '정답을 미리 알아버리는것을 막으세요!',
        '6': '무슨뜻인지 알고싶으면 클릭하세요!',
        '7': '정답 보여주지 않기',
        '8': '간헐적으로 여러분들을 축하해 드려요!',
        '9': '(더욱 열심히 학습하실수 있을거에요.)',
        '10': '간헐적 보상',
        '11': '정답을 읽기 힘들도록 만들어요!',
        '12': '(연구에 따르면 학습효과를 끌어올려 준답니다!)',
        '13': '난독화',
        '14': '쉬는시간 설정',
        '15': '학습 코스 중간중간에 짧은 휴식시간을 줘요!',
        '16': '(연구에 따르면 이런 짧은 휴식은 학습효율을 올려줘요!)',
        '17': '숨 돌리기',
        '18': '고정된 시간 마다 휴식을 취하는것은 생산성을 올리는 것으로 이미 잘 알려져 있죠!',
        '19': '(연구에 따르면 52분을 학습하고 17분을 휴식하는 것이 가장 효과적이래요!)',
        '20': '긴 휴식:',
        '21': '추천 휴식 비율',
        '22': '뽀모도로',
        '23': '학습 :',
        '24': '휴식 :',
        '25': '짧은 휴식 :',
        '26': '반복:',
        '27': '긴 휴식:',
        '28': '집중력 음악',
        '29': '1. 우주선',
        '30': '2. 도시',
        '31': '3. 숲속',
        '32': '4. 비',
        '33': '흥미진진하게 공부하세요',
        '34': '도파민 부스팅 모드',
        '35': '학습하는 동안 집중력을 높여주는 조용한 소리'
      },
      'Turn on Sound': '소리 켜기',
      'Turn Off Sound': '소리 끄기',
      'Deactivate All': '전부 끄기',
      'Activate All': '전부 켜기',
      'Limit Node Height': '노드 높이 제한',
      'Restore': '복구하기',
      '& Close Others': '& 나머지 닫기',
      'The URL for sharing is copied': '공유 URL이 복사되었습니다.',
      explanationForChatMemo: {
        '1': '생각나는대로 쓰고, 날려버리세요.',
        '2': '노트가든의 어디서든 alt+q만 누르면 사용할 수 있습니다.',
        '3': '{{combo}}로 닫으세요.',
        '4': '연습장에서 alt+q를 누르면 다시 원래의 노드로 복귀할 수 있습니다.',
        '5': 'alt+q를 눌러서 어디서든 연습장을 사용하세요.'
      },
      'History': '지난 기록',
      'Reload': '새로고침',
      'Hard Reload': '빡센 새로고침',
      'No results': '검색 결과 없음',
      'Search and select nodes including their descendants': '하위 노드를 포함하여 검색하고 선택하기',
      'Yes': '네',
      'No': '아니오',
      'Do you really want to end up halfway?': '지금 중단하면 다음에 또 복습 해야해요!',
      'How about installing the desktop version?': '데스크탑 버전을 설치하는 건 어떨까요?',
      'Install': '설치',
      'Loading Configs': '설정 불러오기',
      'Reset Configs': '설정 초기화',
      'Files': '파일',
      'Bookmarks': '북마크',
      'Learn': '학습하기',
      'To Do List': '할 일 목록',
      'Export': '내보내기',
      'ChatMemo': '연습장',
      'Help': '도움말',
      'Check as Questions': '문제로 만들기',
      'Font': '글꼴',
      'Highlight': '형광펜',
      'Box Highlight': '테두리 형광펜',
      'Numbered List': '번호 매기기',
      'Heading': '제목',
      'Convert to a Spreadsheet Node': '스프레드시트로 전환하기',
      'Convert to a Document Node': '문서로 전환하기',
      'Image': '이미지',
      'Drawing': '그림',
      'Code': '코드',
      'More Menus': '더보기',
      'Go to Sign Up': '가입하러 가기',
      'My Page': '내 정보',
      'Dashboard': '대시보드',
      'Settings': '설정',
      'Shared Nodes': '공유된 노드',
      'Deleted Nodes': '삭제된 노드',
      'Dark Mode': '야간모드',
      'Preferences': '설정',
      'Import / Export': '불러오기 / 내보내기',
      'Memorize Records': '학습 기록',
      'Close': '닫기',
      'Learned': '학습됨',
      'Current Streak': '연속 학습 일수',
      'Longest Streak': '최장 연속 학습 일수',
      'Level': '레벨',
      'Next Level': '다음 레벨',
      'Points to the Next Level': '다음 레벨까지...',
      'Synapses': 'Garden point',
      'Run Count': '학습 횟수',
      'Complete Count': '학습 완료 횟수',
      totalNotes: '총 노트 수 : {{count}}',
      totalNotes_plural: '총 노트 수: {{count}}',
      totalQuestions: '총 지식 수: {{count}}',
      totalQuestions_plural: '총 지식 수: {{count}}',
      New: '새 질문',
      'To Review': '모르는 지식',
      '~ 10 days': '~ 10 일',
      '10 ~ 100 days': '10 ~ 100일',
      '100 ~ days': '100 ~ 일',
      'Status': '상태',
      'Predicted Ratings': '조이의 추천',
      'Kind': '종류',
      'Show': '보기',
      'predictedRatings': '조이는 <1/>라고 예측해!',
      'Easy': '쉬움',
      'easy': '쉬움',
      'Normal': '보통',
      'normal': '보통',
      'Hard': '어려움',
      'hard': '어려움',
      'Fail': '모름',
      'fail': '모름',
      'Node': '노드',
      'Row': '행',
      'Fragment': '이미지 문제',
      Blank: '빈칸',
      Deleted: '삭제됨',
      'Include Skipped Notes': '생략된 문제 포함하기',
      'Open in a Big Window': '큰 창으로 열기',
      'Remove from the Board': '대시보드에서 지우기',
      'Add Charts': '차트 더하기',
      'Untitled': '제목 없음',
      'Add a New Document': '새 문서 추기',
      'Nothing Found': '결과 없음',
      'There is nothing to insert from Waiting Items of Type 1': '타입 1에서 불러올 항목이 없습니다.',
      insertedFromT1: '{{itemName}} 타입 1에서 삽입하기',
      'Collapse': '접고펴기',
      'Expand': '확대',
      'Remove from Bookmarks': '북마크에서 지우기',
      'Add node': '노드 추가하기',
      'Transfer': '이동',
      'Move': '이동하기',
      'Upload Type 2 Node': 'type 2 노드 업로드하기',
      'Spreadsheet Node': '스프레드시트 노드',
      'Open in a New Window': '새로운 창에서 열기',
      'Enter This Node': '이 노드 입력하기',
      'Toggle Visibility of Child Nodes': '하위 노드 보기/접기',
      'Add a Node Upside': '위에 노드 추가하기',
      'Add a Node Downside': '아래에 노드 추가하기',
      'tab': 'tab',
      'shift+tab': 'shift+tab',
      'Transfer It to Down': '아래로 이동하기',
      'Transfer It to Up': '위로 이동하기',
      'Focus on the Parent Node': '한칸 위 노드로 가기',
      'Focus on the Upper Node': '윗 노드로 가기',
      'Focus on the Lower Node': '아래 노드로 가기',
      'This triangle has no interaction': '이 삼각형은 상호작용이 없습니다',
      'Increase font size': '글자 크기 키우기',
      'Decrease font size': '글자 크기 줄이기',
      Question: '질문',
      Answer: '정답',
      'It shows multiple cards in the Memorize section': '학습시 여러개의 카드를 함께 보여줍니다',
      'Show Multiple Cards': '카드 여러 장 보기',
      'front': '글꼴',
      'back': '돌아가기',
      'Select columns to show': '열을 선택해서 보기',
      'You can\'t have a column with that name': '그 이름의 열을 생성할수 없어요!',
      'You can\'t have columns with the same name': '같은이름의 열은 생성할 수 없어요!',
      'Start Something': '스프레드 시트 만들기',
      'Name of new Column': '새 열의 이름',
      'Add Column': '열 추가 하기',
      'Delete Column': '열 삭제 하기',
      'Delete Selected Rows': '선택된 행 삭제하기',
      'In the Memorize section, it covers all the parts you have cropped': '선택한 부분이 모두 학습코스에 반영됩니다!',
      'Otherwise, it covers only the parts you need to recall.': '그렇지 않으면, 여러분이 모르는 내용만 반영됩니다!',
      'It shows multiple fragments in the Memorize section': '학습 코스에서 여러개의 문제들을 볼 수 있습니다.',
      'Show Multiple Fragments': '복수 문제 보기',
      '\'Media Answer\' is to cover part of the original media and guess what the part was.': '미디어 문제는 미디어의 일부분을 가리고 해당 부분이 무엇인지 맞추는 것입니다.',
      '\'Text Answer\' is to look at a part of the original media and guess what the text you entered was.': '글 문제는 원래 글의 일부분을 보고 당신이 입력했던 글이 무엇인지 맞추는 것입니다.',
      'Media Answer': '미디어 문제',
      'Text Answer': '글 문제',
      'Sharing stopped': '공유 중지하기',
      'URL for sharing is copied': '공유 URL이 복사되었습니다.',
      'Top Root': '노트 가든',
      'LearnObit follows a tree structure': '노트가든은 트리 구조 노트입니다.',
      ' and this is the top-level root node': '그리고 이것은 최상위 노드입니다.',
      'Scroll Up': '올리기',
      'Scroll Down': '내리기',
      'Focus on Last Focused Node': '마지막에 본 노드 보기',
      'Focus on the Node of This Window': '이 창의 노드 보기',
      'Focus on Last Opened Window': '마지막으로 열었던 창 보기',
      'Focus on Previously Focused Window': '이전에 봤던 창 보기',
      'Enter the Parent Node': '상위 노드 입력하기',
      'Toggle ChatMemo': '연습장 보기/접기',
      'Toggle Menu': '메뉴 보기/접기',
      'Close All Except for This Window': '이 창 외에 모두 닫기',
      'Expand Window': '창 확대하기',
      'Split Window': '창 분할하기',
      'Close Window': '창 닫기',
      'Long Break Time!': '쉬는 시간입니다~!',
      'Typing Unfiltered Stream of Consciousness, And Then Throw It Away': '의식의 흐름대로 아무말이나 써보세요! 그리고 날려버리세요!',
      'Fight Distractions': '산만함을 떨쳐버리세요!',
      'Skip Break': '휴식 건너뛰기',
      inhale: '숨 들이마시세요',
      hold: '잠깐 멈추세요.',
      exhale: '숨 내뱉으세요.',
      takeBreath: '{{count}}번 깊은 숨을 쉬세요.',
      takeBreath_plural: '{{count}}번 깊은 숨을 쉬세요.',
      pomo: '{{count}} 뽀모',
      pomo_plural: '{{count}} 뽀모',
      'Full Screen': '전체화면',
      'Limit of volume in a course': '코스당 최대 문제 개수',
      delayOn1: '{{delayValue}} 시를 기준으로 코스가 갱신됩니다!',
      delayOn2: '노트 가든은 일 단위로 학습일정을 갱신합니다! 밤 늦게까지 학습을 하다가 코스가 갱신되는 일이 없도록 막으세요! (평소 여러분들이 일어나는 시간으로 설정하세요!)',
      'Descendants of the node that was failed to recall': '모르는 노드의 하위 노드를 코스에 포함 할까요?',
      'Make all notes appear': '전부 포함 하기',
      'Make direct child notes (1 depth) not to appear': '한칸 아래 노드만 제외하기',
      'Make all descendant notes never appear': '전부 제외하기',
      'Fit the order of courses tightly to the tree structure': '트리구조에 최적화된 형태로 코스를 생성합니다.',
      'The number of questions(s)': '문제 동시 노출 정도',
      'Predicted Rating': '조이의 추천',
      'To the easier rating than the last rating': '쉽다고 예측하는 중요도 가중치',
      'Interval Weight': '간격 가중치',
      'Difficulty Weight': '난이도 가중치',
      'How many fail records are required to allow the predicted rating to fail': '암기에 몇번 실패해야 다음도 실패할것이라 예측할까요?',
      'Spaced Repetition': '간격 반복 학습 알고리즘',
      'Algorithm Description': '알고리즘 설명',
      'Rating Values': '레이팅 값',
      'Set exactly how much difficulty each rating represents (the higher, the easier)': '각 난이도별 상대적 거리',
      'Default': '초기값',
      'Apply': '적용',
      'Exclude selected nodes and their descendants in courses': '선택된 노드 전체를 학습에서 제외하기',
      'Include all selected nodes and their descendants in courses': '선택된 노드 전체를 학습에 포함하기',
      'without considering the review schedule': '(복습 스케줄과 상관없이 복습하기)',
      'Run courses only for selected nodes and their descendants': '선택된 노드 전체를 학습하기',
      'All Checked': '모두 체크됨',
      'Some Checked': '일부만 체크됨',
      'Skip All': '모두 건너뛰기',
      'Show Answers': '정답 보기',
      'Edit imperatively': '바로 편집하기',
      'Save and Close': '저장 후 닫기',
      'Learning Tricks': '학습보조기능',
      'youFormedSynapses': ' <2>{{synapses}}</2> 의 가드닝 포인트를 얻었습니다!!',
      'Learn These Parts': '이 부분 학습하기',
      'You Have Nothing to Review': '복습할 것이 없습니다.',
      'Run the Course': '학습 시작하기',
      youLearnedNote: '{{count}}개 노트를 학습했습니다.',
      youLearnedNote_plural: '{{count}}개 노트를 학습했습니다.',
      Before: '학습 전',
      After: '학습 후',
      'It\'s Prevented to Check Answers by the Learning Tricks Option': '학습 보조기능 중 \'정답보여주지 않기\'에 의해 금지되어있습니다.',
      'Press to change color. Nothing else but quite useful': '색깔을 바꾸려면 버튼을 누르세요. 별 거 아니지만 유용합니다.',
      'Don\'t Know': '모른다',
      'Know': '안다',
      'Skip': '건너뛰기',
      'Know (enter)': '안다 (enter)',
      'Don\'t Know (1)': '모른다 (1)',
      'Previous': '이전',
      'All Notes Are Rated': '모든 노트가 평가됨',
      'Rate Unrated Notes at Once': '평가되지 않은 노트를 한 번에 평가하기',
      'Move on to the Next (enter)': '다음으로 넘어가기(엔터)',
      'Rate with the Predicted Rating': '조이의 추천으로 레이팅 하기',
      'Failed to Recall': '모름',
      'Switch to Detailed Ratings': '세분화된 평가항목으로 바꾸기',
      'Switch to Simple Ratings': '단순한 평가항목으로 바꾸기',
      'Here you can change your rating': '여기에서 당신의  평가를 수정할 수 있습니다.',
      'The mobile version is not ready yet': '모바일버전은 준비중입니다.',
      'The user did not allow this node to be shared': '사용자가 이 노드를 공유하지 않습니다.',
      'Shared node was deleted by the user': '공유된 노드가 사용자에 의해 삭제되었습니다.',
      'Something went wrong': '뭔가 잘못됐어요!',
      'Go to LearnObit Page': '노트가든 홈 페이지 방문하기',
      'Something went wrong and the data was not saved properly. Sorry.': '뭔가 잘못되어 데이터가 저장되지 않았습니다.',
      'Any changes you make here will not be reflected in the original data': '여기서 작업한 변경사항은 원래 데이터에 저장되지 않습니다.',
      'Data for guest users will not be saved': '방문자용 데이터는 저장되지 않습니다.',
      'Any changes you make in Playground will not be saved': '연습장에서 작업한 변경사항은 저장되지 않습니다.',
      'Organize for Memorizing': 'Organize for Memorizing',
      'Organize for Reference': 'Organize for Reference',
      'LearnObit has updated to the latest version!': '노트가든이 최신버전으로 업데이트 되었어요!',
      'LearnObit is ready for offline usage': '오프라인으로 사용할 준비가 되었어요!',
      'Nodes saved': '저장 되었어요!',
      nodeDeleted: '{{nodeTitle}}가 삭제되었어요!',
      'It\'s offline mode': '오프라인 모드에요!',
      'It\'s online mode': '온라인 모드에요!',
      'LearnObit is being opened in several windows. it might work in a strange way.': '동시에 여러 창에서 사용하고 있어요!. 수정사항이 바로 반영되지 않을 수 있어요!.',
      'Try LearnObit without signing up': '로그인 없이 노트가든을 사용해 보세요',
      'Sign up here': '회원가입',
      'Back': '뒤로',
      'Next': '다음',
      'Last': '마지막',
      'CANCEL': '취소',
      'Email': '이메일',
      'Continue as a guest': '손님계정으로 계속 하기',
      'Sign in with email': '이메일로 로그인 하기',
      'Sign in with google': '구글로 로그인 하기',
      'Choose files...': '파일 선택',
      'Recent': '최근 학습내역',
      'Nothing Here': '비어있음',
      'Course Settings': '학습범위 세부 설정',
      'Include These All': '반드시 포함할 부분 선택',
      'Notes saved': '노트가 저장되었어요',
      'Learn All Parts': '전체 학습',
      'Add a To Do item (alt + t Anywhere)': '할 일을 추가하세요! (어디서나 alt + t)',
      'Enter': '입력',
      'Clear': '삭제',
      'Sign Out': '로그아웃',
      'New Page': '새 창',
      'Nodes that Link to This Node': '이 노드와 연결된 노드',
      'Completed It All!': '대단해요! 학습을 완료하셨네요!',
      'Results': '학습 결과',
      'Hide All Fragments': '다른 문제 가리기',
      'Notes': '노트들',
      'Not Rated': '레이팅되지 않음',
      'Don\'t Check Answers': '답을 확인하지마세요!',
      'Why? Read More': '왜냐고요? 이것을 읽어보세요!',
      'Copy': '복사',
      'Paste': '붙여넣기',
      'Control': '노드 조작',
      'Add Node': '노드 추가하기',
      'Refresh': '새로고침',
      'Move Focus': '커서 이동하기',
      'Right click on the circle of the node': '이 노드의 동그라미를 오른쪽 클릭하세요',
      windowExplanation: '이 윈도우는 {{nodeTitle}}를 위한 것이에요',
      'Sign In': '로그인',
      'Sign Up': '회원가입',
      'Copy the URL for Sharing': '공유를 위한 URL을 복사하기',
      // -----------------------------------------------------------------------------------------------------------
      'Generate cloze by clicking words': 'Generate cloze by clicking words',
      'Loading Data': 'Loading Data',
      'Open a Rich Editor': 'Open a Rich Editor',
      'Change Language': '언어 바꾸기',
      English: '영어',
      Korean: '한국어'
    }
  }

}

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'en',
    // debug: true,
    // lng: 'ko',

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  })

export default i18n
